import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import {
  CandidateList,
  ElectionResult,
  ElectoralSearch,
  PageNotFound,
  VoterCount,
} from "../screens";
import { Loader, Navbar } from "../components";
import { get, isNotNullOrEmpty } from "../functions";

const AppRoutes = () => {
  const [loading, setLoading] = useState(true);
  const [routes, setRoutes] = useState([]);

  const addNavbar = (element) => {
    return (
      <React.Fragment>
        <Navbar menu={routes} />
        {element}
      </React.Fragment>
    );
  };

  const elements = [
    {
      element: addNavbar(<ElectoralSearch />),
      path: "/election/electoral-search",
    },
    {
      element: addNavbar(<ElectionResult />),
      path: "/election/result",
    },
    {
      element: addNavbar(<VoterCount />),
      path: "/election/voter/count",
    },
    {
      element: addNavbar(<CandidateList />),
      path: "/election/candidate/list",
    },
  ];

  const getRoutes = async () => {
    const response = await get("/public/menus");
    if (response?.status === "Success") {
      setRoutes(response.data);
    }
    setLoading(false);
  };

  useEffect(() => {
    getRoutes();
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <Routes>
      {/* {isNotNullOrEmpty(routes[0]) && (
        <Route path="/" element={<Navigate to={routes[0].path} />} />
      )}
      {routes.map((ele) =>
        elements.map(({ path, element }, ind) => {
          if (ele.path === path) {
            return <Route key={ind} path={path} element={element} />;
          }
        })
      )} */}
      <Route path="/" element={addNavbar(<ElectoralSearch />)} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default AppRoutes;
